<template>
    <div class="main-grids">
        <div class="recommended">
            <div class="recommended-grids">
                <div class="recommended-info">
                    <h3>
                        <span v-for="(data, index) in listTitle" :key="index">
                            <router-link :to="{name: 'VideoList', params:{ scid:data.id }}" class="cate-title">{{data.title}}</router-link>
                            <span v-if="listTitle.length != index+1 && listTitle != 'Loading...'"> > </span>
                        </span>
                    </h3>
                    <ul class="tag-categroy-list">
                        <li v-for="(data, index) in videoCategorys" :key="index"><router-link class="tag-category" :to="{name: 'VideoList', params:{ scid:data.id }}">{{data.title}}</router-link></li>
                    </ul>
                </div>
                <layoutVideo :data="videoList"></layoutVideo>
            </div>
            <div class="page__content">
                <pagination :per-page="pageSize" :records="videoListTotal" v-model="page" :options="pageOptions" @paginate="myCallback"></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import layoutVideo from '@/components/VideoList'

export default {
  name: '',
  data () {
    return {
      listTitle: 'Loading...',
      videoCategorys: [],
      videoList: [],
      videoListTotal: 0,
      page: parseInt(this.$route.query.p) || 1,
      pageSize: 8,
      pageRecords: 0,
      pageOptions: {
        chunk: 10,
        theme: 'bootstrap3',
        texts: {
          count: '顯示 {from} 到 {to} 筆 / 總共 {count} 筆|總共 {count} 筆|總共 {count} 筆'
        }
      }
    }
  },
  props: ['meta'],
  components: {
    layoutVideo
  },
  watch: {
    '$route' (to, from) {
      this.videoCategorys = []
      this.videoList = []
      this.page = parseInt(this.$route.query.p) || 1
      this.pageRecords = 0
      this.videoListTotal = 0
      this.listTitle = 'Loading...'
      this.$nextTick(() => {
        this.getVideoCategoryLists()
        this.getVideoList()
      })
    }
  },
  mounted () {
    this.getVideoCategoryLists()
    this.getVideoList()
  },
  methods: {
    getVideoCategoryLists () {
      let self = this
      var categoryId = (self.$route.params.scid) ? self.$route.params.scid : self.$route.params.cid
      this.$http.get('/getVideoCates/' + categoryId).then(function (response) {
        if (response.data.list_title.length === 0) {
          self.$router.push('/')
        }
        self.listTitle = response.data.list_title
        self.videoCategorys = response.data.list
      })
    },
    getVideoList () {
      let self = this
      var categoryId = (self.$route.params.scid) ? self.$route.params.scid : self.$route.params.cid
      this.$http.get('/getVideos/' + categoryId + '/' + self.pageSize + '/' + self.page).then(function (response) {
        self.videoList = response.data.list
        self.videoListTotal = response.data.total
        self.page = parseInt(self.page)
      })
    },
    myCallback: function (page) {
      let self = this
      var scid = (self.$route.params.scid === 'undefined') ? null : self.$route.params.scid
      self.$router.push({ name: 'VideoList', params: { cid: self.$route.params.cid, scid: scid }, query: { p: page } })
    }
  },
  metaInfo () {
    return {
      titleTemplate: this.listTitle[this.listTitle.length - 1].title + ' - %s'
    }
  }
}
</script>

<style scoped>
    .cate-title{
        display: inline;
        color: #073E8A;
        text-decoration: none;
    }
    .cate-title:hover{
        color: #185c73;
        text-decoration: underline;
    }
    .tag-categroy-list{
        margin: 3rem 0rem;
        padding-left: 0;
        list-style-type: none;
    }
    .tag-categroy-list li{
        display: inline-block;
    }
    .tag-category{
        font-weight: 700;
        font-size: 1.5rem;
        line-height: 1;
        padding: .4rem .65rem;
        margin: .5rem;
        border: 1px solid;
        color: rgba(15,98,171,.7);
    }
    .tag-category:hover{
        text-decoration: none;
        cursor: pointer;
    }
</style>
